import { createAction } from 'redux-actions'

export const UPDATE_CHURN_SURVEY = 'UPDATE_CHURN_SURVEY'
export const updateChurnSurvey = createAction(UPDATE_CHURN_SURVEY)



// WEBPACK FOOTER //
// ./actions/churn-survey.js